export default "__VITE_ASSET__Bp$W4yA0__"